import { render, staticRenderFns } from "./dcops_move_board.vue?vue&type=template&id=3bffa914&scoped=true"
import script from "./dcops_move_board.vue?vue&type=script&lang=js"
export * from "./dcops_move_board.vue?vue&type=script&lang=js"
import style0 from "./dcops_move_board.vue?vue&type=style&index=0&id=3bffa914&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bffa914",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bffa914')) {
      api.createRecord('3bffa914', component.options)
    } else {
      api.reload('3bffa914', component.options)
    }
    module.hot.accept("./dcops_move_board.vue?vue&type=template&id=3bffa914&scoped=true", function () {
      api.rerender('3bffa914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/boardManage/dataOperation/dcops_move_board.vue"
export default component.exports